// extracted by mini-css-extract-plugin
export default {"deliveredLand":"styles_deliveredLand__laoMF","disputed":"styles_disputed__b2zMm","waitingForShipping":"styles_waitingForShipping__FbwIi"};